import { motion } from 'framer-motion';
import { DictionaryEntry } from '../types';

interface TermCardProps {
  entry: DictionaryEntry;
  onClick: () => void;
  index: number;
  showLetterWatermark?: boolean;
}

export const TermCard = ({
  entry,
  onClick,
  index,
  showLetterWatermark = true
}: TermCardProps) => {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(0,0,0,0.12)' }}
      onClick={onClick}
      className="bg-white rounded-2xl p-6 cursor-pointer border border-slate-200 hover:border-rose-300 transition-all duration-300 relative overflow-hidden group"
    >
      {/* Watermark lettre en fond */}
      {/* Watermark lettre en fond */}
      {showLetterWatermark && (
        <div className="absolute -top-4 -right-2 text-[10rem] font-serif font-bold text-rose-50 leading-none select-none pointer-events-none group-hover:text-rose-100/50 transition-all duration-500 italic">
          {entry.letter}
        </div>
      )}

      {/* Contenu */}
      <div className="relative z-10">
        {/* Header */}
        <div className="flex justify-between items-start mb-3">
          <div className="flex-1">
            <h3 className="text-2xl font-serif font-bold text-slate-900 mb-1 group-hover:text-rose-600 transition-colors">
              {entry.term}
            </h3>
            <p className="text-xs text-rose-500 font-semibold italic uppercase tracking-wider mb-2">
              {entry.type}
            </p>
          </div>
        </div>

        {/* Définition courte */}
        <p className="text-slate-700 leading-relaxed mb-4">
          {entry.definition}
        </p>

        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          {entry.tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 bg-slate-50 text-slate-500 text-[10px] font-bold uppercase tracking-wider rounded-lg border border-slate-100 group-hover:bg-white group-hover:border-rose-100 group-hover:text-rose-600 transition-colors"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </motion.article>
  );
};
